import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { authBunja } from '@flipster/features/src/shared/auth/state';
import { FormattedMessage } from '@flipster/i18n';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { center, hstack, stack } from '@flipster/styled-system/patterns';
import { token } from '@flipster/styled-system/tokens';

/**
 * User-level global default leverage & margin mode, with fallback to cold-start values
 * (`1x` / `Isolated`) when the user has not set them yet.
 */
export const useDefaultLeverageMarginMode = () => {
  const { userAtom } = useBunja(authBunja);
  const user = useAtomValue(userAtom);
  return {
    defaultLeverage: user?.defaultLeverage ?? 1,
    defaultMarginMode: user?.defaultMarginType ?? 'Isolated',
  };
};

interface Props {
  onClick: () => void;
}

export const DefaultLeverageMarginModeButton = ({ onClick }: Props) => {
  const { defaultLeverage, defaultMarginMode } = useDefaultLeverageMarginMode();

  return (
    <button
      type='button'
      onClick={onClick}
      className={hstack({ w: '100%', justify: 'space-between', alignItems: 'center', mt: 20 })}
    >
      <div className={stack({ textAlign: 'left', gap: 2 })}>
        <div className={css({ textStyle: 'Body/XL/Regular', color: 'content.default.level-4' })}>
          <FormattedMessage id='Trade.r260528.Default_leverage_margin_mode' />
        </div>
        <div className={css({ textStyle: 'Body/S/Regular', color: 'content.default.level-3' })}>
          <FormattedMessage id='Trade.r260528.Currently_set_to' /> {defaultLeverage}x, {defaultMarginMode}
        </div>
      </div>
      <div className={center()}>
        <ChevronRightIcon size={16} color={token('colors.content.default.level-3')} />
      </div>
    </button>
  );
};
